import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import { GoogleLogin } from '@react-oauth/google';
import FirebaseAuth from './FirebaseAuth';
import { setCookie } from '../../views/utils';
import content from '../../content.json';

const brandname = content.brandname;
const login_api_url = process.env.REACT_APP_LOGIN_API_URL;

const AuthModal = ({ isOpen, toggle, onAuthSuccess, onAuthError }) => {
  const [activeTab, setActiveTab] = useState('firebase');
  const [loading, setLoading] = useState(false);

  const handleGoogleAuthSuccess = (credentialResponse) => {
    setLoading(true);
    
    // Use existing Google OAuth flow
    fetch(`${login_api_url}/api/Login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': credentialResponse.credential,
      },
      body: JSON.stringify({ test: 'test' })
    })
    .then((res) => res.json())
    .then((data) => {
      setCookie(`${brandname}_token`, data.token, { 
        path: '/', 
        expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365) 
      });
      
      if (onAuthSuccess) onAuthSuccess(data);
      toggle(); // Close modal
    })
    .catch((error) => {
      if (onAuthError) onAuthError(error);
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const handleFirebaseAuthSuccess = (data) => {
    if (onAuthSuccess) onAuthSuccess(data);
    toggle(); // Close modal
  };

  const handleAuthError = (error) => {
    if (onAuthError) onAuthError(error);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Sign In to Your Account
      </ModalHeader>
      <ModalBody>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === 'firebase' ? 'active' : ''}
              onClick={() => setActiveTab('firebase')}
              style={{ cursor: 'pointer' }}
            >
              Email & Password
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === 'google' ? 'active' : ''}
              onClick={() => setActiveTab('google')}
              style={{ cursor: 'pointer' }}
            >
              Google Sign In
            </NavLink>
          </NavItem>
        </Nav>
        
        <TabContent activeTab={activeTab}>
          <TabPane tabId="firebase">
            <div className="mt-3">
              <FirebaseAuth
                onAuthSuccess={handleFirebaseAuthSuccess}
                onAuthError={handleAuthError}
              />
            </div>
          </TabPane>
          
          <TabPane tabId="google">
            <div className="mt-3 text-center">
              <p className="text-muted mb-4">
                Sign in with your Google account to continue
              </p>
              <GoogleLogin
                scope="openid email profile"
                shape='pill'
                onSuccess={handleGoogleAuthSuccess}
                onError={handleAuthError}
                disabled={loading}
              />
              {loading && (
                <div className="mt-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          </TabPane>
        </TabContent>
      </ModalBody>
    </Modal>
  );
};

export default AuthModal;


